import styled from 'styled-components';
import { Carousel } from '../../../shared/components/carousel';
import { themeColor, themeSize } from '../../../theme/getters';
import { media } from '../../../theme/media';

export const Gallery = styled(Carousel)`
  font-size: 0;

  .slick-dots {
    position: absolute;
    width: auto;
    bottom: 32px;
    right: 28px;
    font-size: 0;

    li {
      padding: 0;
      margin: 0;
      width: auto;
      height: auto;
    }

    li button {
      &:before,
      &:after {
        content: none;
      }

      width: 8px;
      height: 8px;
      box-sizing: border-box;
      border: 1px solid ${themeColor('white')};
      border-radius: 50%;
      margin: 4px;
      padding: 0;
    }

    li.slick-active button {
      background-color: ${themeColor('white')};
    }
  }
`;

export const GallerySlide = styled.div`
  outline: none;
  height: calc(100vh - ${themeSize('header')}px - ${themeSize('contentPadding')}px - 80px);
  position: relative;
  display: block;
  overflow: hidden;
  background-color: ${themeColor('secondaryPink')};

  ${media.tablet`
     height: calc(100vh - ${themeSize('header')}px);
  `}

  ${media.desktopFull`
     height: calc(100vh - ${themeSize('header')}px - ${themeSize('contentPadding')}px * 2);
  `}
`;
